var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-layout"},[_c('app-nav'),_vm._v(" "),_c('div',{staticClass:"app-body",attrs:{"id":"scroll-target"}},[_c('app-header'),_vm._v(" "),_c('app-content')],1),_vm._v(" "),_c('app-aside'),_vm._v(" "),_c('app-snackbar'),_vm._v(" "),_c('app-modal'),_vm._v(" "),_c('app-modal2'),_vm._v(" "),_c('view-files')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-204fda46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app/Layout.vue
// module id = null
// module chunks = 